import Constants from "@usas/ui-web/utils/Constants";

export const localValidate = (formState) => {
  const errors = {};

  if (formState.omeMeetEntryId === Constants.DEFAULT_ID) {
    errors.omeMeetEntryId = 'Selection is required';
  }

  if (formState.orgUnit.length === 0) {
    errors.orgUnit = 'Selection is required';
  }

  return errors;
};

const TeamEntryHQSelectOrgUnitValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
}

export default TeamEntryHQSelectOrgUnitValidation;